/**
 * Created by Jie Gao on 2018-06-14.
 */
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {IScreenViewConfig, ScreenView} from "@nolimitcity/slot-game/bin/core/screen/ScreenView";
import {ParsedGameData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedGameData";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {IResizeData} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {BitmapTextStyleOptions} from "@nolimitcity/slot-game/bin/core/text/BitmapTextStyleOptions";
import {Translation} from "@nolimitcity/slot-game/bin/core/translation/Translation";
import {FontWeight} from "@nolimitcity/slot-launcher/bin/loader/font/FontStatics";
import {TimelineLite, TweenLite} from "gsap";
import {DragonTribeGameModuleConfig} from "../../DragonTribeGameModuleConfig";
import {DragonTribeSoundConfig} from "../../DragonTribeSoundConfig";
import {DragonTribeInitialWinCountUp} from "../../winpresentation/initial/DragonTribeInitialWinCountUp";

export class DTFreespinOutroView extends ScreenView {
    private readonly WIN_NUMBERS_WHITE:BitmapTextStyleOptions = {
        font : {
            name : "NumbersWinCountUp",
            size : 20
        },
        tint : parseInt(("#ffffff").replace(/^#/, ''), 16)
    };

    private _container:PIXI.Container;
    private _infoPanel:PIXI.Container;
    private _youWinText:PIXI.Text;
    private _spinsPlayed:PIXI.Text;
    private _darkOverlay:PIXI.Graphics;
    private _winCountUp:DragonTribeInitialWinCountUp;

    constructor(config:IScreenViewConfig, autoClose:boolean = true) {
        super(config, autoClose);
        this._winCountUp = new DragonTribeInitialWinCountUp({
            font : {
                name : "NumbersWinCountUp",
                size : 20
            },
            tint : parseInt(("#ffffff").replace(/^#/, ''), 16)
        });
    }

    protected createGameGraphics():PIXI.DisplayObject {
        const container:PIXI.Container = new PIXI.Container();
        this._infoPanel = new PIXI.Container();
        this._darkOverlay = new PIXI.Graphics;
        container.addChild(this._darkOverlay);

        const bg:PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures("fs_outro")[0]);
        bg.anchor.set(0.5, 0.5);
        bg.position.set(0, -50);

        this._youWinText = new PIXI.Text(Translation.translate("You won"), {
            fill : 0xffffff,
            fontFamily : "LuckiestGuy",
            fontSize : 38,
            wordWrap : true,
            wordWrapWidth : 300,
            padding : 20,
            breakWords : true
        });
        this._youWinText.anchor.set(0.5);
        this._youWinText.position.set(100, -170);

        this._spinsPlayed = new PIXI.Text("", {
            fill : 0xF8D633,
            fontFamily : "Open Sans",
            wordWrap : true,
            wordWrapWidth : 550,
            fontWeight : FontWeight.LIGHT,
            fontSize : 36
        });
        this._spinsPlayed.anchor.set(0.5);
        this._spinsPlayed.position.set(100, 100);

        this.reset();
        this._winCountUp.position.set(100, -30);
        this._infoPanel.addChild(bg);
        this._infoPanel.addChild(this._youWinText);
        this._infoPanel.addChild(this._spinsPlayed);
        this._infoPanel.addChild(this._winCountUp);
        container.addChild(this._infoPanel);
        this._container = container;
        return container;
    }

    protected onResizeGameGraphics(resizeData:IResizeData):void {
        if(resizeData.orientation == Orientation.PORTRAIT) {
            this._infoPanel.scale.set(1.6, 1.6);
        } else {
            this._infoPanel.scale.set(1.0, 1.0);
        }
        this._container.position.set(this._screenWidth * 0.5, this._screenHeight * 0.5);
        this._darkOverlay.clear();
        this._darkOverlay.beginFill(0x000000, 0.8);
        this._darkOverlay.drawRect(-this._screenWidth / 2, -this._screenHeight / 2, this._screenWidth, this._screenHeight);
    }

    protected startPresentation(data:ParsedGameData, onShowComplete:() => void):void {
        const hasWon:boolean = (data.totalWin > 0),
            // #315
            totalWinBelowStake: boolean = DragonTribeGameModuleConfig.featurePrice.isWinBelowStake(),
            countUpDuration: number = (totalWinBelowStake ? 0 : 2.37);

        this.alpha = 0;
        const tl:TimelineLite = new TimelineLite({
            paused : true,
            onComplete : () => {
                this._button.visible = true;
                super.startPresentation(data, onShowComplete);
            }
        });
        tl.add(() => {
            this._button.visible = false;
            this._spinsPlayed.visible = true;
            this._spinsPlayed.text = ` ${Translation.translate("Spins played: ")} ${(<ParsedGameData>data).numberOfFreespinsPlayed!.toString()} `;
            this._spinsPlayed.position.y = (hasWon ? 100 : 0);
            this._youWinText.visible = hasWon && !totalWinBelowStake;
            this._winCountUp.visible = false;

            // #315
            if (!totalWinBelowStake) {
                SlotGame.sound.playEffect(DragonTribeSoundConfig.FS_OUTRO);
            }
        });
        tl.add(TweenLite.fromTo(this, 1, {alpha : 0}, {alpha : 1}));
        tl.add(() => { DragonTribeGameModuleConfig.soundPlayer.switchToMainMusic(true);});
        if(hasWon) {
            tl.add([
                () => {
                    this._winCountUp.visible = true;

                    // #315
                    if (!totalWinBelowStake) {
                        SlotGame.sound.playEffect(DragonTribeSoundConfig.COUNTUP);
                        SlotGame.sound.playEffect(DragonTribeSoundConfig.FS_OUTRO_COINS);
                    }
                },
                this._winCountUp.getCountUpAnimation(0, data.totalWin, countUpDuration)
            ]);

            // #315
            if (!totalWinBelowStake) {
                tl.add(() => {
                    SlotGame.sound.playEffect(DragonTribeSoundConfig.COUNTUP_END);
                    SlotGame.sound.stopEffect(DragonTribeSoundConfig.COUNTUP);
                });
            }
        }
        tl.play(0);
    }

    private reset():void {
        this._youWinText.visible = false;
        this._winCountUp.visible = false;
        this._spinsPlayed.visible = false;
    }
}